import React from 'react';
import { IIconProps } from './utils';

export const EditPreview = ({
  fill = 'currentColor',
  height = 30,
  width = 30,
  ...rest
}: IIconProps) => (
  <svg fill="none" height={height} viewBox="0 0 26 26" width={width} xmlns="http://www.w3.org/2000/svg" {...rest}>
    <path
      d="M18 3.40423L10.387 11.0172C10.1161 11.2881 9.93659 11.6369 9.8736 12.0149L9.26285 15.6794C9.15916 16.3015 9.6985 16.8408 10.3206 16.7372L13.9851 16.1264C14.3631 16.0634 14.7119 15.8839 14.9828 15.613L22.5958 8M18 3.40423L18.7024 2.70182C19.9715 1.43273 22.0291 1.43273 23.2982 2.70181C24.5673 3.9709 24.5673 6.0285 23.2982 7.29759L22.5958 8M18 3.40423L22.5958 8M24.25 14.25L24.25 20.5C24.25 22.5711 22.5711 24.25 20.5 24.25H19.25M11.75 1.75H5.5C3.42893 1.75 1.75 3.42893 1.75 5.5V6.75M1.75 11.75V20.5C1.75 22.5711 3.42893 24.25 5.5 24.25H19.875"
      stroke={fill}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.5"
    />
  </svg>
);
